"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var React = _interopRequireWildcard(require("react"));
var _common = require("../../types/common");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _InContextAlert = require("../InContextAlert");
var _BannerModule = _interopRequireDefault(require("./Banner.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Banner = exports.Banner = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    semantic,
    leftIconType = 'solid',
    alignment = 'top',
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InContextAlert.InContextAlert, {
      ...props,
      leftIconType: leftIconType,
      semantic: semantic,
      ref: ref,
      testId: testId,
      classNames: {
        ...classNames,
        wrapper: (0, _classify.default)(_BannerModule.default.bannerContainer, {
          [_BannerModule.default.neutral]: semantic === _common.ALERT_SEMANTIC.neutral,
          [_BannerModule.default.success]: semantic === _common.ALERT_SEMANTIC.success,
          [_BannerModule.default.information]: semantic === _common.ALERT_SEMANTIC.information,
          [_BannerModule.default.warning]: semantic === _common.ALERT_SEMANTIC.warning,
          [_BannerModule.default.danger]: semantic === _common.ALERT_SEMANTIC.danger,
          [_BannerModule.default.topAligned]: alignment === 'top',
          [_BannerModule.default.bottomAligned]: alignment === 'bottom'
        }, classNames?.wrapper),
        alertText: (0, _classify.default)(classNames?.alertText),
        actionContainer: (0, _classify.default)(_BannerModule.default.alertContainer, classNames?.actionContainer)
      }
    })
  });
});